import React from "react";

interface ProductTypeTagProps {
    tagText: string;
}

const ProductTypeTag: React.FC<ProductTypeTagProps> = (props) => {
    return (
        <span className="blj-store-locator__tag">
            {props.tagText}
        </span>
    );
}

export default ProductTypeTag;